/**
 * Format helpers
 */
export const formatRupiah = (n) => {
  if (n == null || isNaN(n)) return "Rp 0";
  return "Rp " + Number(n).toLocaleString("id-ID");
};

export const formatNumber = (n) => {
  if (n == null || isNaN(n)) return "0";
  return Number(n).toLocaleString("id-ID");
};

// Skala ringkas untuk angka besar di dashboard: 1.250.000 → "1,25 Juta"
const COMPACT_UNITS = [
  { value: 1e12, label: "Triliun" },
  { value: 1e9, label: "Miliar" },
  { value: 1e6, label: "Juta" },
];

/**
 * Angka besar ditulis dalam satuan Juta/Miliar/Triliun dengan 2 digit desimal.
 * Angka di bawah 1 juta tetap memakai pemisah ribuan biasa (mis. 250.000).
 */
export const formatCompactNumber = (n) => {
  if (n == null || isNaN(n)) return "0";
  const num = Number(n);
  // Ambang 0,99995 agar angka seperti 999.999.999 naik ke "1,00 Miliar",
  // bukan dibulatkan menjadi "1.000,00 Juta".
  const unit = COMPACT_UNITS.find((u) => Math.abs(num) >= u.value * 0.99995);
  if (!unit) return num.toLocaleString("id-ID");
  const scaled = (num / unit.value).toLocaleString("id-ID", {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });
  return `${scaled} ${unit.label}`;
};

export const formatCompactRupiah = (n) => {
  if (n == null || isNaN(n)) return "Rp 0";
  return "Rp " + formatCompactNumber(n);
};

export const formatDate = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleDateString("id-ID", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return iso;
  }
};

export const formatDateTime = (iso) => {
  if (!iso) return "-";
  try {
    const d = new Date(iso);
    return d.toLocaleString("id-ID", { day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit" });
  } catch {
    return iso;
  }
};

export const statusClass = (status) => {
  const map = {
    "Draft PO": "status-draft",
    "PO Terkirim": "status-dikirim",
    "PO Diproses": "status-diproses",
    "Dalam Pengiriman": "status-pengiriman",
    "Barang Diterima": "status-diterima",
    "Selesai": "status-selesai",
    "Dibatalkan": "status-dibatalkan",
    "Aktif": "status-aktif",
    "Nonaktif": "status-nonaktif",
    "Habis": "status-habis",
  };
  return map[status] || "status-draft";
};

// Alamat tujuan pengiriman PO dalam satu baris.
export const alamatTujuanPO = (po) => {
  if (!po) return "";
  return [
    po.dest_alamat,
    po.dest_kelurahan && `Kel. ${po.dest_kelurahan}`,
    po.dest_kecamatan && `Kec. ${po.dest_kecamatan}`,
    po.dest_kota,
    po.dest_provinsi,
  ].filter(Boolean).join(", ");
};
